(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nested-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var slides = document.querySelectorAll('.swiper-slide');
  var verticalSwiper = new Swiper('#vertical-slider', {
    direction: "vertical",
    spaceBetween: 0,
    centeredSlides: false,
    slidesPerView: "1",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    mousewheel: true,
    keyboard: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        translate: [0, "-0%", -1],
      },
      next: {
        translate: [0, "100%", 0],
      },
    },
    speed: 1000,
    on: {
      init: function () {
        applyTextColor(this.activeIndex);
        forcePlayVideos(this.activeIndex);
      },
      slideChange: function () {
        applyTextColor(this.activeIndex);
        forcePlayVideos(this.activeIndex);
      },
    },
  });

  // Function to force play videos on iOS devices
  function forcePlayVideos(activeIndex) {
    const currentSlide = slides[activeIndex];
    if (!currentSlide) return;
    
    const videos = currentSlide.querySelectorAll('video.slide-video');
    videos.forEach(function(video) {
      // Ensure video is muted and has playsinline for iOS
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      
      // Force play with promise handling
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function(error) {
          // Autoplay was prevented, try again after a short delay
          setTimeout(function() {
            video.play().catch(function(err) {
              console.log('Video autoplay failed:', err);
            });
          }, 100);
        });
      }
    });
  }

  // Force play all videos on initial load (for iOS)
  function initVideos() {
    const allVideos = document.querySelectorAll('.slide-video');
    allVideos.forEach(function(video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      
      // Try to play immediately
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function(error) {
          // If autoplay fails, try again when video is loaded
          video.addEventListener('loadeddata', function() {
            video.play().catch(function(err) {
              console.log('Video autoplay failed:', err);
            });
          }, { once: true });
        });
      }
    });
  }

  // Initialize videos on page load
  initVideos();
  
  // function applyTextColor(index) {
  //   const currentSlide = slides[index];
  //   const forceBlackText = currentSlide.getAttribute('data-force-black') === 'true';
  //   const headerItems = document.querySelectorAll('.header__menu-item span');
  //   const headerLogo = document.getElementById('header-logo');
  //   const svgPaths = document.querySelectorAll('#header-account-logo path');
  //   const svgPathsCart = document.querySelectorAll('#addtocart-logo path');
  //   const svgPathsWhatsapp = document.querySelectorAll('#whatsapp-logo path');
  //   const headerLogoImg = document.querySelector('.header__heading-link img');
  //   const hamburgerIcon = document.querySelectorAll('.icon-hamburger g');
  //   const textColor = forceBlackText ? 'black' : 'white';
  //   headerItems.forEach((item) => {
  //     item.style.color = textColor;
  //   });
  //   if (headerLogo) headerLogo.style.color = textColor;
  //   svgPaths.forEach((path) => (path.style.stroke = textColor));
  //   svgPathsCart.forEach((path) => (path.style.fill = textColor));
  //   svgPathsWhatsapp.forEach((path) => (path.style.fill = textColor));
  //   hamburgerIcon.forEach((path) => (path.style.stroke = textColor));

  //   if (headerLogoImg) {
  //     headerLogoImg.src = textColor === 'white'
  //       ? 'https://cdn.shopify.com/s/files/1/0418/6429/8657/files/im_logo_image.png?v=1737977010'
  //       : 'https://cdn.shopify.com/s/files/1/0418/6429/8657/files/image_logo_3cb8beac-5f22-4880-aece-072baa1dcc63.png?v=1715248046';
  //   }
  // }

  function applyTextColor(index) {
    const currentSlide = slides[index];
    const forceBlackText = currentSlide.getAttribute('data-force-black') === 'true';

    const headerItems = document.querySelectorAll('.header__menu-item span');
    // const headerLogo   = document.getElementById('header-logo');
    const headerLogo   = document.querySelectorAll('#header-logo');
    const svgPaths     = document.querySelectorAll('#header-account-logo path');
    const svgPathsCart = document.querySelectorAll('#addtocart-logo path');
    const svgPathsWA   = document.querySelectorAll('#whatsapp-logo path');
    const headerLogoImg = document.querySelector('.header__heading-link img');
    const hamburgerIcon = document.querySelectorAll('.icon-hamburger path');
    const cartCount = document.querySelector('.cart-count-bubble');

    const textColor = forceBlackText ? 'black' : 'white';

    headerItems.forEach((item) => { item.style.color = textColor; });
    // if (headerLogo) headerLogo.style.color = textColor;
    headerLogo.forEach((p) => { p.style.color = textColor; });
    svgPaths.forEach((p) => { p.style.stroke = textColor; });
    svgPathsCart.forEach((p) => { p.style.fill = textColor; });
    svgPathsWA.forEach((p) => { p.style.fill = textColor; });
    hamburgerIcon.forEach((g) => { g.style.stroke = textColor; });
    if (cartCount) cartCount.style.color = textColor;

    // Flip the logo colors via CSS filter instead of swapping src
    if (headerLogoImg) {
      // When forceBlackText=true -> invert(0) (no invert); false -> invert(1)
      const invertValue = forceBlackText ? 0 : 1;

      // Optional: smooth transition
      if (!headerLogoImg.style.transition) {
        headerLogoImg.style.transition = 'filter 150ms ease';
      }

      headerLogoImg.style.filter = `invert(${invertValue})`;
      // If your logo is dark-on-light originally and needs extra contrast when inverted,
      // you can tweak further:
      // headerLogoImg.style.filter = `invert(${invertValue}) contrast(1.05)`;
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
